import { createAction, props } from '@ngrx/store';

export const sendMetricsData = createAction(
    '[CORE METRICS INTERACTION] Send Metrics Data',
    props<{ eventName: string; data: JSON }>()
);
export const appInitialization = createAction('[APP INITIALIZER] App initialization started');
export const appInitializationFinished = createAction('[APP LOADER EFFECTS] App initialized finished');
